// pages/Orders.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const Orders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/orders`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      // FIX: backend returns { success: true, orders: [...] }
      // Old code: setOrders(response.data) → was setting the whole object, not the array
      setOrders(response.data.orders || []);
    } catch (error) {
      console.error('Error fetching orders:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="container"><p>Loading orders...</p></div>;

  if (orders.length === 0) {
    return (
      <div className="container">
        <h1>My Orders</h1>
        <p>You haven't placed any orders yet.</p>
      </div>
    );
  }

  return (
    <div className="orders-page">
      <div className="container">
        <h1>My Orders</h1>
        <div className="orders-list">
          {orders.map(order => (
            <div key={order.id} className="order-card">
              <div className="order-header">
                <h3>Order #{order.id}</h3>
                <span className={`status-badge status-${order.status}`}>
                  {order.status}
                </span>
              </div>
              <p>Date: {new Date(order.order_date).toLocaleDateString()}</p>
              <p>Total: ₹{order.total_amount}</p>
              <p>Payment: {order.payment_method?.toUpperCase()} — {order.payment_status}</p>
              <div className="order-items">
                {order.items &&
                  order.items.map(item => (
                    <div key={item.id} className="order-item">
                      <span>{item.product_name} x {item.quantity}</span>
                      <span>₹{item.price}</span>
                    </div>
                  ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Orders;